import React from 'react';
import { Box, Grid } from '@mui/material';
import ReUsableBanner from '../../../../components/common/ReUsableBanner';
import ContactUsForm from './ContactUsForm';
import Address from './Address';
// import { Root } from '../../../../components/component/ThemeComponent';

const ContactUsBanner: React.FC = () => {
	const asideImage = '/assets/contactus-banner.png';
	const smallTitle = 'Contact us';
	const headerContent = 'Get in Touch for Exceptional Catering Services!';
	const paraContent = `We would love to be a part of your special occasions! Whether it's a wedding, engagement, birthday, housewarming, corporate event, or any celebration, our catering services are here to make your event truly memorable.`;

	return (
		<Box>
			<ReUsableBanner
				asideImage={asideImage}
				smallTitle={smallTitle}
				headerContent={headerContent}
				paraContent={paraContent}
			/>
			<Box margin={'2rem'}>
				<div
					style={{
						// backgroundImage: 'url("/assets/hero-banner.png")',
						backgroundSize: 'cover',
						backgroundRepeat: 'no-repeat',
						width: '100%',
						// Remove duplicate height
						// height: '876px',
						minHeight: 'auto',
						// height: 'calc(100vh - 60px)', // this is now correct
						// maxHeight: '55px',
						position: 'relative',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: '0',
					}}
				>
					<Grid container>
						<Grid size={{ xs: 12, sm: 12, md: 6 }} gap={'2'}>
							<Address />
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 6 }} gap={'2'}>
							<ContactUsForm />
						</Grid>
					</Grid>
				</div>
			</Box>
		</Box>
	);
};

export default ContactUsBanner;
